/**
 * @param { Array<{ id: string, name: string, salary: object }>} employees
 */

function format(employees) {
	if (!employees?.length) {
		return [];
	}

	return employees?.map((employee) => {
		const current = employee?.salary?.current ?? 0;
		const forecast = employee?.salary?.forecast ?? 0;

		return {
			...employee,
			salary: {
				...employee?.salary,
				current: current * -1,
				forecast: forecast * -1,
			},
		};
	});
}

export default format;
